module.exports = __webpack_public_path__ + "static/media/banner-dien-tu.8167b8d9.jpg";